var map = {
	"./notification-status-alert.png": "./src/assets/images/notification-status-alert.png",
	"./notification-status-check.png": "./src/assets/images/notification-status-check.png",
	"./notification-status-question.png": "./src/assets/images/notification-status-question.png",
	"./notification-status-wait.png": "./src/assets/images/notification-status-wait.png",
	"./notification-status-x.png": "./src/assets/images/notification-status-x.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/notification\\-status\\-.*\\.png$";